export const OTP_PROVIDER_QUERY_KEYS = {
	PROVIDERS: {
		ALL: ['otp-provider', 'providers'] as const,
		LIST: () => [...OTP_PROVIDER_QUERY_KEYS.PROVIDERS.ALL, 'list'] as const,
		DETAIL: (id: string) =>
			[...OTP_PROVIDER_QUERY_KEYS.PROVIDERS.ALL, 'detail', id] as const,
		ACTIVE: () => [...OTP_PROVIDER_QUERY_KEYS.PROVIDERS.ALL, 'active'] as const,
	},
} as const

export const STATUS_OPTIONS = [
	{ value: 'true', label: 'เปิดใช้งาน' },
	{ value: 'false', label: 'ปิดใช้งาน' },
] as const
